"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("store");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const authorization_1 = require("utils/authorization");
const hauling_style_1 = __importDefault(require("../hauling.style"));
const hauling_action_1 = __importDefault(require("../hauling.action"));
const custom_grid_1 = __importDefault(require("./custom-grid"));
const hauling_column_1 = require("../hauling.column");
const header_menu_1 = __importDefault(require("components/molecules/header-menu"));
const card_1 = require("components/molecules/card");
const modal_1 = require("components/molecules/modal");
const Hauling = () => {
    const { isError, dataGrid, isLoading, isSuccess, dataStates, errorMessage, documentExport, isLoadingExportPdf, isLoadingExportExcel, } = (0, store_1.useAppSelector)(state => state.report.hauling);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const dispatch = (0, react_redux_1.useDispatch)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isExternal = (0, authorization_1.isUserExternal)(userData.contractor_name);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Report', 'Hauling Operation');
    const handleExternalInternalState = (isExternal) => {
        var _a;
        if (isExternal) {
            const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: {
                    logic: 'and',
                    filters: [
                        ...((_a = dataStates.filter) === null || _a === void 0 ? void 0 : _a.filters) || [],
                        { field: 'contractor_name', operator: 'eq', value: userData.contractor_name }
                    ]
                } });
            return newDataStates;
        }
        else {
            return dataStates;
        }
    };
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (isLoading) {
                dispatch(hauling_action_1.default.getDataGrid(handleExternalInternalState(isExternal)));
            }
            if (documentExport.content) {
                // Noob code ↓↓↓↓ maybe change it if found better way
                const a = document.createElement('a'); //Create <a>
                const filetype = documentExport.filetype === 'pdf'
                    ? 'application/pdf'
                    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                a.href = `data:${filetype};base64,` + documentExport.content; //Image Base64 Goes here
                a.download = documentExport.filename; //File name Here
                a.click(); //Downloaded file
                dispatch(hauling_action_1.default.clearDocuments());
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [isLoading, isAuthorized, documentExport, fullScreen, isExternal]);
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(hauling_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(hauling_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        dispatch(hauling_action_1.default.onDataStateChange(newDataStates));
    };
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(header_menu_1.default, { theme: appTheme, title: 'Hauling Report', isLoading: isLoading, isReportPit: isAuthorized.view, isLoadingExportPdf: isLoadingExportPdf, isLoadingExportExcel: isLoadingExportExcel, onExportToPdf: () => {
                    dispatch(hauling_action_1.default.onClickMutation({ mutationMode: false, isLoadingExportPdf: true }));
                    dispatch(hauling_action_1.default.exportDocuments(Object.assign(Object.assign({}, handleExternalInternalState(isExternal)), { type: 'pdf' })));
                }, onExportToExcel: () => {
                    dispatch(hauling_action_1.default.onClickMutation({ mutationMode: false, isLoadingExportExcel: true }));
                    dispatch(hauling_action_1.default.exportDocuments(Object.assign(Object.assign({}, handleExternalInternalState(isExternal)), { type: 'xls' })));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(hauling_action_1.default.getDataGrid(dataStates));
                    dispatch(hauling_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, style: { 'zIndex': 10 }, errorMessage: errorMessage, onClose: () => dispatch(hauling_action_1.default.onCloseError()) }), (0, jsx_runtime_1.jsx)(card_1.Card, Object.assign({ style: hauling_style_1.default.cardGridStyle(appTheme) }, { children: (0, jsx_runtime_1.jsx)(card_1.CardBody, { children: (0, jsx_runtime_1.jsx)(custom_grid_1.default, { pageable: true, sortable: false, cardGrid: false, scrollable: 'scrollable', fullScreen: fullScreen, sort: dataStates.sort, dataStates: dataStates, style: hauling_style_1.default.gridHeight, dataGrid: dataGrid, onFilterChange: onFilterChange, columns: hauling_column_1.HaulingColumnProps, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v) }) }) }))] }));
};
exports.default = Hauling;
